// extracted by mini-css-extract-plugin
module.exports = {"CheckList":"CheckList_CheckList__ftxfi","CheckListIcon":"CheckList_CheckListIcon__SGMY1"};